(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    const wrapper = document.querySelector("[data-collection-local-search]");
    if (!wrapper) return;

    // サイド検索のフォーム＆入力欄（header-search の中身を想定）
    const form =
      wrapper.querySelector("form") ||
      wrapper.closest("form"); // 念のため
    const input =
      wrapper.querySelector('input[type="search"], input[type="text"]') ||
      (form ? form.querySelector('input[name="q"]') : null);

    if (!form || !input) return;

    // メインのコレクション商品グリッド（「最近見た商品」は除外）
    const grids = Array.from(document.querySelectorAll(".product-grid")).filter(
      (el) => !el.closest(".recently-viewed-section")
    );
    if (grids.length === 0) return;

    const items = [];
    grids.forEach((grid) => {
      grid.querySelectorAll(".product-grid__item").forEach((li) => items.push(li));
    });

    // 0件メッセージ
    const emptyId = "collection-local-search-empty";
    let emptyMsg = document.getElementById(emptyId);
    if (!emptyMsg) {
      emptyMsg = document.createElement("p");
      emptyMsg.id = emptyId;
      emptyMsg.className = "collection-local-search-empty";
      emptyMsg.style.display = "none";
      emptyMsg.textContent = "該当する商品がありません。";
      grids[0].after(emptyMsg);
    }

    // 正規化＆テキスト抽出
    const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();
    const getText = (node) => {
      const title =
        node.querySelector("[data-product-title], .card__heading, .product-card__heading");
      const sku = node.querySelector(".card__sku, [data-product-sku]");
      let text = "";
      if (title) text += " " + title.textContent;
      if (sku) text += " " + sku.textContent;
      // 念のため全テキストも対象
      text += " " + node.textContent;
      return norm(text);
    };

    // 初回キャッシュ
    const cache = new Map();
    items.forEach((li) => cache.set(li, getText(li)));

    function applyFilter(q) {
      const query = norm(q);
      let shown = 0;

      if (!query) {
        items.forEach((li) => (li.style.display = ""));
        emptyMsg.style.display = "none";
        return;
      }

      const tokens = query.split(" ");
      items.forEach((li) => {
        const hay = cache.get(li);
        const ok = tokens.every((t) => hay.includes(t));
        li.style.display = ok ? "" : "none";
        if (ok) shown++;
      });

      emptyMsg.style.display = shown ? "none" : "";
    }

    // フォーム送信を横取り（ページ遷移しない）
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      applyFilter(input.value);
    });

    // 入力と同時に絞り込み（お好みで外してOK）
    input.addEventListener("input", function () {
      applyFilter(input.value);
    });
  });
})();
